import React, { useState, useEffect } from 'react'
import { Button, ToggleButton, ToggleButtonGroup } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { BACKEND_URI } from '../config'
import { toast } from 'react-toastify'



function Orders({ user, setorderType, setorderID, useFunds, setuseFunds }) {
  const navigate = useNavigate()
  const [userOrders, setuserOrders] = useState({})
  const [searchTerm, setSearchTerm] = useState('')
  const [filteredOrders, setFilteredOrders] = useState(userOrders)
  const [orderTypeShown, setorderTypeShown] = useState("UNCOMPLETE") // Toggle state for approved/unapproved
  const [amountPayedDict, setAmountPayedDict] = useState({})
  const [areYouSureDeleteButtonVisible, setareYouSureDeleteButtonVisible] =
      useState(false)
  const [deleteButtonShown, setDeleteButtonShown] = useState()


  // Handle search input change
  const handleSearch = e => {
    const term = e.target.value.toLowerCase()
    setSearchTerm(term)
    filterOrders(term, orderTypeShown)
  }

  const handleUpdateOrder = async (order_id, order_amountPayed, order_status) => {
    console.log(order_amountPayed)
        try {
          const token = localStorage.getItem('token') // JWT for authentication
          const response = await fetch(
            `${BACKEND_URI}/api/update-order`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({ order_id, order_amountPayed, order_status }), // Send custom invite code
            }
          )
  
          const data = await response.json()
  
          if (!response.ok) {
            throw new Error(data.error || 'Failed to update order')
          }
  
          toast.success('Order Successfully updated')
        } catch (err) {
          toast.error('Error updating order.')
        }


        setAmountPayedDict(prev => ({
            ...prev,
            [order_id]: order_amountPayed
        }))

        let temp_order = userOrders.find(order => order._id === order_id);
        temp_order.status = order_status

        let difference = temp_order.amountPayed - order_amountPayed
        temp_order.amountNeeded += difference

        let temp_user_orders = userOrders

        temp_user_orders[order_id] = temp_order

        setuserOrders(temp_user_orders)

        filterOrders(searchTerm, orderTypeShown, temp_user_orders)
    }


    const handleDeleteOrder = async order_id => {
        try {
          const token = localStorage.getItem('token') // JWT for authentication
          const response = await fetch(`${BACKEND_URI}/api/delete-order`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ order_id }),
          })
    
          const data = await response.json()
    
          if (!response.ok) {
            throw new Error(data.error || 'Failed to delete order')
          }
    
          const updatedOrders = userOrders.filter(o => o._id !== order_id)
    
          // Update the state with the new codes
          setuserOrders(updatedOrders)
          filterOrders(searchTerm, orderTypeShown, updatedOrders)
          setareYouSureDeleteButtonVisible(false)
    
          toast.success('Successfully deleted order')
        } catch (err) {
          console.error('Error deleting order:', err)
          toast.error(err.message || 'Error deleting order.')
        }
      }
    

  function filterOrders(term, orderTypeShow, user_orders) {
    let userOrdersTemp = ''
    if (user_orders) {
      userOrdersTemp = user_orders
    } else {
      userOrdersTemp = userOrders
    }

    if (term === '') {
        const filtered = userOrdersTemp.filter(orderTemp => {
            if(orderTemp.status)
                return orderTemp.status
                    ? orderTemp.status.toLowerCase() === orderTypeShow.toLowerCase()
                    : false
        })
        setFilteredOrders(filtered)
    } else {
      const filtered = userOrdersTemp.filter(orderTemp => {
        const delivery_method = orderTemp.isPickup ? "picking up": "ship"

        const matchesSearch =
          orderTemp._id.toLowerCase().includes(term.toLowerCase()) ||
          orderTemp.createdAt.includes(term) ||
          (orderTemp.order_items &&
            orderTemp.order_items.some(
              item =>
                item.title.toLowerCase().includes(term.toLowerCase()) ||
                item.category.toLowerCase().includes(term.toLowerCase()) ||
                item.price.includes(term)
            )) ||
          (orderTemp.userInfo &&
            (orderTemp.userInfo.username
              .toLowerCase()
              .includes(term.toLowerCase()) ||
              orderTemp.userInfo.firstname
                .toLowerCase()
                .includes(term.toLowerCase()) ||
              orderTemp.userInfo.lastname
                .toLowerCase()
                .includes(term.toLowerCase()) ||
              orderTemp.userInfo.email
                .toLowerCase()
                .includes(term.toLowerCase()) ||
              orderTemp.userInfo.phonenumber
                .toLowerCase()
                .includes(term.toLowerCase()))) ||
          orderTemp.amountNeeded.toString().includes(term) ||
          orderTemp.amountPayed.toString().includes(term) ||
          delivery_method.includes(term)

         
          return matchesSearch && orderTemp.status
            ? orderTemp.status.toLowerCase() === orderTypeShow.toLowerCase()
            : false
      })
      setFilteredOrders(filtered)
    }
  }

  useEffect(() => {
    const fetchUserOrders = async () => {
      try {
        const token = localStorage.getItem('token')
        const response = await fetch(`${BACKEND_URI}/api/user-orders`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })

        const data = await response.json()

        setuserOrders(data)

        setAmountPayedDict(prevState => {
            const updatedDict = { ...prevState };
            data.forEach(order => {
                updatedDict[order._id] = order.amountPayed;
            });
            return updatedDict;
        });

        filterOrders('', orderTypeShown, data)
      } catch (error) {
        console.error('Error fetching user information:', error)
      }
    }

    fetchUserOrders()
  }, [])

  const handleToggle = (event, newStatus) => {
    if (newStatus !== null) {
      setorderTypeShown(newStatus)
      filterOrders(searchTerm, newStatus)
    }
  }


  return (
    <div
      style={{
        padding: '20px',
        border: '1px solid #ddd',
        borderRadius: '10px',
        backgroundColor: '#f9f9f9',
      }}
    >
      <h2>Order History</h2>

      <input
        type='text'
        placeholder={
          user.admin
            ? 'Search by id, order items, date, user, shipping, or payment amount needed/completed'
            : 'Search by id, order items, date, shipping, or payment amount needed/completed'
        }
        value={searchTerm}
        onChange={handleSearch}
        style={{
          padding: '10px',
          width: '100%',
          borderRadius: '5px',
          border: '1px solid #ccc',
          marginBottom: '20px',
        }}
      />

      <ToggleButtonGroup
        color='primary'
        value={orderTypeShown}
        exclusive
        onChange={handleToggle}
        aria-label='Order Type'
        sx={{ marginBottom: 3 }}
      >
        <ToggleButton value='UNCOMPLETE' aria-label='UNCOMPLETE'>
          UNCOMPLETE
        </ToggleButton>
        <ToggleButton value='COMPLETE' aria-label='COMPLETE'>
          COMPLETE
        </ToggleButton>
      </ToggleButtonGroup>
      <div></div>


      {filteredOrders.length > 0 ? (
        filteredOrders.map((order, idx) => (
          <div
            key={order._id}
            style={{
              marginBottom: '20px',
              padding: '10px',
              border: '1px solid #ccc',
              borderRadius: '5px',
            }}
          >

            {user.admin ? <>
                <p>
                <strong>Order ID:</strong> {order._id}
                </p>
                <label>
                <strong>Amount Payed: </strong>$
                </label>
                <input value={amountPayedDict[order._id] || 0} 
                    onChange={(e) => {
                        setAmountPayedDict(prev => ({
                            ...prev,
                            [order._id]: e.target.value
                        }));
                }}/>
                <Button
                onClick={(e) => handleUpdateOrder(order._id,  amountPayedDict[order._id], order.status)}
                variant='contained'
                style={{ marginLeft: '10px', backgroundColor: '#51a4ac' }}
                >Submit</Button>
            </> : <>
                <p>
                <strong>Order ID:</strong> {order._id}
                </p>
                <p>
                <strong>Amount Payed: </strong>$
                {
                    order.amountPayed
                }
                </p>
            </>}

            <p>
            <strong>Amount Needed: </strong>$
            {
                order.amountNeeded
            }
            </p>

            <p>
                <strong>Order Items:</strong>
            </p>
            <ul>
                {order.order_items.map((item, idx) => (
                <li key={idx}>
                    {item.title} - {item.quantity} pcs ({item.category})
                </li>
                ))}
            </ul>

            {order.userInfo && (
              <>
                <p>
                  <strong>User Information:</strong>
                </p>
                <ul>
                  <li>UserName: {order.userInfo.username}</li>
                  <li>First Name: {order.userInfo.firstname}</li>
                  <li>Last Name: {order.userInfo.lastname}</li>
                  <li>Email: {order.userInfo.email}</li>
                  <li>Phone Number: {order.userInfo.phonenumber}</li>
                </ul>
              </>
            )}
            <p><strong>Delivery Method: </strong> {order.isPickup ? "Picking up": "Ship"}</p>

            <p>
              <strong>Created At:</strong>{' '}
              {new Date(order.createdAt).toLocaleString()}
            </p>

            {user.admin && <>
                <ToggleButtonGroup
                color='primary'
                value={order.status}
                exclusive
                onChange={(e, newValue) =>
                    handleUpdateOrder(order._id, order.amountPayed, newValue)
                }
                aria-label='order status'
                sx={{ marginBottom: 3 }}
                >
                <ToggleButton value='UNCOMPLETE' aria-label='UNCOMPLETE' color='success'>
                    UNCOMPLETE
                </ToggleButton>
                <ToggleButton value='COMPLETE' aria-label='COMPLETE' color='error'>
                    COMPLETE
                </ToggleButton>
                </ToggleButtonGroup>

                    <div />
                <button
                onClick={e => {
                    setareYouSureDeleteButtonVisible(true)
                    setDeleteButtonShown(idx)
                }}
                style={
                    areYouSureDeleteButtonVisible && deleteButtonShown === idx
                    ? styles.buttonDisabled
                    : styles.cancelButton
                }
                >
                Delete
                </button>
                <div />

                {areYouSureDeleteButtonVisible && deleteButtonShown === idx && (
              <div style={{ marginTop: '.5rem', marginBottom: '.5rem' }}>
                <label>Are you sure you want to delete this order?</label>
                <div />
                <button
                  style={styles.saveButton}
                  onClick={e => handleDeleteOrder(order._id)}
                >
                  Yes
                </button>
                <button
                  style={styles.cancelButton}
                  onClick={e => setareYouSureDeleteButtonVisible(false)}
                >
                  No
                </button>
              </div>
                )}
            </>}
          </div>
        ))
      ) : (
        <p>No users found.</p>
      )}
    </div>
  )
}

const styles = {
  addButton: {
    backgroundColor: '#51a4ac',
    color: 'white',
    border: 'none',
    padding: '0.5rem 1rem',
    cursor: 'pointer',
    borderRadius: '4px',
    marginRight: '1rem',
  },
  cancelButton: {
    padding: '0.5rem 1rem',
    backgroundColor: '#c53b3a',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  buttonDisabled: {
    backgroundColor: 'grey',
    color: 'white',
    border: 'none',
    padding: '0.5rem 1rem',
    borderRadius: '4px',
    fontSize: '0.9rem',
  },
  saveButton: {
    marginTop: ".5rem",
    padding: '0.5rem 1rem',
    backgroundColor: '#51a4ac',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    marginRight: '0.5rem',
  },
}

export default Orders
